import { render, staticRenderFns } from "./CategoryOverview.vue?vue&type=template&id=7f1764aa&"
import script from "./CategoryOverview.vue?vue&type=script&lang=js&"
export * from "./CategoryOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports